import { normalSanatizerBRL } from "src/utils/functions";
import { Vis_PraResult } from "../Vista-Prazo";
export const VistaPrazoTable = ({ results }: { results: Vis_PraResult }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">
              Informações da Compra
            </th>
            <th className="px-4 py-2 text-center truncate">Detalhes</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Valor do Produto
            </td>

            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.produto)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Numero de Parcelas
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.numeroParcela}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Desconto a Vista
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.valorDesconto}%
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Valor a ser Pago
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.vistaFinal)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
